import React, { useState } from 'react'
import {connect} from 'react-redux';
import {
    bltHomeSelect
} from "../../../redux/selector/bltHomeSelector"
import { getApplicationById } from '../BLTReview/BLTReviewUtils';
import {BLTNavigationTop} from '../BLTCommon/BLTNavigationTop'
import './BLTHome.styles.scss'
import BLTHomeQueue from './BLTHomeQueue';
import {push} from 'connected-react-router'
import {
    APPLICATION_STATUS_APPROVED_ISSUED,
    APPLICATION_STATUS_WITHDRAWN_APPROVED,
    LICENCE_STATUS_WITHDRAWN,
    ROUTE_PATH,
} from '../../../app/constants'
import { postApplicationPayload } from '../../../redux/slice/businessLicenceApplicationSlice';
import { setQueueItem } from '../../../redux/slice/bltReviewSlice';
import { fetchApplicationWithIdAndSetStore } from '../../../redux/slice/collectionApplicationSlice';
import { fetchApplicationWithId } from '../../../redux/slice/bltHomeSlice';
import BLTHomeFilter from './BLTHomeFilter'
import { addAgentApplication, setCurrentAgentApplicationId } from '../../../redux/slice/additionalApplicationsSlice';
import { setAgencyApplication } from '../../../redux/slice/primaryAgencyApplicationSlice';

function BLTHomePage(props) { 

    const {dispatch, bltHome} = props
    const {queueHeaders, queueItems, paginationData, queue} = bltHome
    const [page, setPage] = useState(paginationData?.currentPage || 1); 

    /*
     * Always when "Review" button is clicked, fetch the latest status of the 
     * application and mark it as "read-only" if the status is "UNDER_REVIEW"
     */
    const handleReviewItemClick = (qItemId) => { 
        
        const itemToReview = queue.find(q => q.id === qItemId)
        
        if(itemToReview?.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED
            && itemToReview?.businessApplicationHistoryData?.find(change => !change.validated)) { 
                dispatch(push({
                    pathname : ROUTE_PATH.BLT_CHANGE_REVIEW.replace(':qItemId', qItemId),
                    state : {forChangeRequest : true}
                }))  
        } else { 
            // if the itemToReview 
            if(itemToReview.originalApplicationId === null) {
                dispatch(getApplicationById(qItemId)).then(() => {
                    dispatch(push(ROUTE_PATH.BLT_REVIEW.replace(':qItemId', qItemId)))
                })
            } else {
                dispatch(getApplicationById(qItemId, true)).then(() => {
                    dispatch(push(ROUTE_PATH.BLT_REVIEW.replace(':qItemId', `archiveId=${qItemId}`)))
                })
            }
        }
    }

    /* 
     * The implementation of below function assumes that the qItem is either a 
     * collector or debt management application.
     */
    const handleConfirmWithdrawnByClient = (qItemId, sendQueueRequestCB) => {

        dispatch(fetchApplicationWithId(qItemId))
        .then(qItem => {
            if(qItem) {
                
                // if the status is already withdrawn_approved, then just ignore
                if (qItem.applicationStatus === APPLICATION_STATUS_WITHDRAWN_APPROVED)
                    return

                const applicationJson = {...qItem, ...{
                    applicationStatus : APPLICATION_STATUS_WITHDRAWN_APPROVED,
                    licenceStatus: LICENCE_STATUS_WITHDRAWN,
                    changeType : "SAVE"
                }}
                
                dispatch(postApplicationPayload(applicationJson))
                    .then(submittedData => {
    
                        // find the app data
                        if(qItem.businessApplicationId) {
                            dispatch(fetchApplicationWithIdAndSetStore(qItem.businessApplicationId))
                            .then(data => {
                                // set the current collector
                                dispatch(addAgentApplication(applicationJson))
                                dispatch(setCurrentAgentApplicationId(qItemId))
                                dispatch(setQueueItem(applicationJson))
                                let nextUrl = ROUTE_PATH.BLT_DECISION_SUMMARY
                                // move to the next screen
                                dispatch(push(nextUrl.replace(':status', APPLICATION_STATUS_WITHDRAWN_APPROVED.toLowerCase())))
                            })
                        }
                        else {
                            dispatch(setAgencyApplication(applicationJson))
                            dispatch(setQueueItem(applicationJson))
                            let nextUrl = ROUTE_PATH.BLT_DECISION_SUMMARY
                            // move to the next screen
                            dispatch(push(nextUrl.replace(':status', APPLICATION_STATUS_WITHDRAWN_APPROVED.toLowerCase())))
                        }
                    })
            }
        })
    }

    return (
        <>
            <BLTNavigationTop setPage={setPage} />
            
            <div className={"container"}>
                <div className="row">
                    <div className="col-12">
                        <h1>Home</h1>
                    </div>
                    <BLTHomeFilter setPage={setPage}/>
                    <div className="botomMarginMedium">&nbsp;</div>
                    <BLTHomeQueue 
                        {...props}
                        headers={queueHeaders}
                        queueItems={queueItems} 
                        paginationData={paginationData}
                        onReviewButtonClick={handleReviewItemClick}
                        onConfirmWithdrawnByClient={handleConfirmWithdrawnByClient}
                        page={page}
                        setPage={setPage}
                    />
                </div>
            </div>
        </>
    )
}

export default connect(bltHomeSelect)(BLTHomePage)
